































































import Vue from 'vue'
import { Component, Emit } from 'vue-property-decorator'

import { ActiveBotLicenseSteps } from '../types'

@Component({
  data() {
    return {
      ActiveBotLicenseSteps
    }
  }
})
export default class AboutStep extends Vue {
  isAboutVideoModalOpen = false

  @Emit()
  updateStep(step:ActiveBotLicenseSteps | null) {
    return step
  }
}
